import React, { useCallback } from 'react';

import { commitDraftToList } from '../utils';
import {
  SA_COLORS,
  RecipientChipsWrap,
  RecipientChip,
  RecipientChipRemove,
  RecipientInput,
} from '../styled-comps';
import Icon from './icon';

// Chip-style email recipient input shared by the compose modal (To/CC/BCC)
// and the external-card reply form (To/CC). Draft state lives in the parent
// so it can flush an uncommitted draft at send time via commitDraftToList.
const RecipientChipsInput = ({
  value,
  onChange,
  draft,
  onDraftChange,
  placeholder,
  onError,
}) => {
  const commit = useCallback(() => {
    const { list, invalid } = commitDraftToList(draft, value);
    if (invalid) {
      if (onError) onError(`Invalid recipient email: ${invalid}`);
      return;
    }
    onChange(list);
    onDraftChange('');
  }, [draft, value, onChange, onDraftChange, onError]);

  const handleKeyDown = useCallback(
    e => {
      if (e.key === 'Enter' || e.key === ',') {
        e.preventDefault();
        commit();
      } else if (e.key === 'Backspace' && !draft && value.length > 0) {
        onChange(value.slice(0, -1));
      }
    },
    [commit, draft, value, onChange],
  );

  return (
    <RecipientChipsWrap alignItems="center">
      {value.map(email => (
        <RecipientChip key={email} variant="body3" color={SA_COLORS.TEXT_PRIMARY}>
          {email}
          <RecipientChipRemove onClick={() => onChange(value.filter(e => e !== email))}>
            <Icon name="close" size={10} />
          </RecipientChipRemove>
        </RecipientChip>
      ))}
      <RecipientInput
        name="recipient"
        autoComplete="off"
        value={draft}
        onChange={e => onDraftChange(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={commit}
        placeholder={
          value.length ? 'Type another email, then press Enter or comma' : placeholder
        }
      />
    </RecipientChipsWrap>
  );
};

export default RecipientChipsInput;
